export default "__VITE_ASSET__D7Aqr2Rn__"